import { useTranslation } from "react-i18next";

import {
  Message,
  MessageContent,
  MessageHeader,
} from "simplydo/react/ui/message";

export const AssessmentScoreProcessingWarning = () => {
  const { t } = useTranslation();
  return (
    <Message color="orange" style={{ marginBottom: 15 }}>
      <MessageHeader>
        {t("challenge.format.assessmentScoreProcessing.header")}
      </MessageHeader>
      <MessageContent>
        {t("challenge.format.assessmentScoreProcessing.body")}
      </MessageContent>
    </Message>
  );
};
